import { Box, Grid } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled, { keyframes } from 'styled-components';

import { IStyledToast } from './Toast.types';

export const StyledToastWrapper = styled(Grid)`
  &:first-child {
    margin-bottom: ${rem('40px')};
  }

  margin-bottom: ${rem('16px')};

  @media screen and (min-width: ${({ theme }) => theme?.breakpoints?.l}) {
    margin-right: ${rem('50px')};
  }

  @media screen and (max-width: ${({ theme }) => theme?.breakpoints?.l}) {
    margin-bottom: ${rem('16px')};
  }
`;

const scaleToFullWidth = keyframes`
 0% { transform: scale(0)}
 100% { transform: scale(1)}
`;

export const StyledToast = styled(Box)<IStyledToast>`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  align-items: center;
  position: relative;
  border-left: 10px solid ${({ toastTypeColor }) => toastTypeColor};
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: ${rem('8px')};
  box-shadow: ${({ theme }) =>
    `0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)}`};
  padding: ${'24px'};
  margin-left: auto;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - ${rem('32px')});
    height: ${rem('2px')};
    margin: 0 ${'15px'};
    background-color: ${({ toastTypeColor }) => toastTypeColor};
    animation: ${scaleToFullWidth} 5s;
    transform-origin: left center;
  }
`;
